import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from 'components/popup/components/DoubleButton';
import Select, {createSelectItem} from 'components/Select';
import VS from 'constants/ValidationShema';
import PropTypes from "prop-types";
import {ContractorDocumentType, ContractorDocumentTypeSelectItems} from "constants/ContractorDocumentType";
import {RoundType} from "constants/RoundType";
import {TrueFalseWithEmpty} from "constants/TrueFalseItems";

const useStyle = makeStyles(theme => ({
    gridContainer: {
        marginBottom: theme.spacing(2)
    },
    fileName: {
        width: 480,
        marginBottom: theme.spacing()
    },
    select: {
        width: 180
    },
    rodoSelect: {
        width: 200
    },
    typeSelect: {
        width: 230,
    }
}));

function SelectOfferFilesType(
    {
        items,
        onCancel,
        onSubmit,
        positions,
        onePositionMode,
        roundType,
        formSubmit,
    }) {

    const classes = useStyle();

    const formId = useId();
    const typeId = 'type';
    const positionId = 'position';
    const containsRodoId = 'containsRodo';

    const getPositionItems = () => {
        const map = positions.map(x => createSelectItem(x.positionId, Tr("part_x", {x: x.order})));
        if(roundType === RoundType.BASE) {
            map.unshift(createSelectItem(0, Tr("whole_demand")));
        }
        return map;
    }

    const generateItems = (formikProps) => {
        if (items.length === 0) {
            return <Typography>{Tr("file_extension_error")}</Typography>
        }
        return items.map((item, i) => {
            return (
                <GridBlock key={i} justify="space-between" alignItems="center">
                    <Typography className={classes.fileName}> {item.name}</Typography>

                    <Select
                        id={containsRodoId + i}
                        formikProps={formikProps}
                        items={TrueFalseWithEmpty}
                        label={Tr('contains_rodo')}
                        className={classes.rodoSelect}
                    />

                    <Select
                        id={typeId + i}
                        formikProps={formikProps}
                        items={ContractorDocumentTypeSelectItems()}
                        label={Tr('document_type')}
                        className={classes.typeSelect}
                    />

                    {!onePositionMode && <Select
                        id={positionId + i}
                        formikProps={formikProps}
                        items={getPositionItems()}
                        label={Tr('assignment')}
                        className={classes.select}
                    />}

                </GridBlock>
            )
        })
    };

    const submitForm = () => {
        formSubmit[formId]()
    };

    const handleSubmit = (values) => onSubmit(values, items)

    const generateInitialValues = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[typeId + i] = null;
            obj[containsRodoId + i] = '_';
            if (!onePositionMode)
                obj[positionId + i] = null;
        }
        return obj
    };

    const generateValidationSchema = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[typeId + i] = VS.stringNotOneOf([ContractorDocumentType.RODO], Tr('required_field'));
            obj[containsRodoId + i] = VS.any();
            if (!onePositionMode)
                obj[positionId + i] = VS.anyRequired();
        }
        return VS.object(obj)
    };

    if (items === undefined) return '';
    return (
        <Dialog
            open
            title={Tr('select_document_type')}
            titleCentered
            maxWidth="lg"
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('add')}
                onClickFirst={onCancel}
                onClickSecond={submitForm}
            />}
        >
            <Form
                onSubmit={handleSubmit}
                id={formId}
                initialValues={generateInitialValues()}
                validationSchema={generateValidationSchema()}
            >
                {(formikProps) => (
                    <>
                        <GridBlock column className={classes.gridContainer}>
                            {generateItems(formikProps)}
                        </GridBlock>


                    </>
                )}
            </Form>

        </Dialog>
    )
}

SelectOfferFilesType.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired
    })).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    positions: PropTypes.arrayOf(PropTypes.object).isRequired,
    onePositionMode: PropTypes.bool.isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
};

export default connect((state) => ({
    formSubmit: state.form,
}), {})(SelectOfferFilesType);